<template>
  <div>
    <div class="center content-inputs items-end">
      <div class="form-input">
        <vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
                  v-model="name"/>
		  <span v-if="errors.first('name')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <div class="form-input">
        <vs-input label="Email" name="email" v-validate="'required|email|min:3'"
                  v-model="email"/>
		  <span v-if="errors.first('email')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
                  v-model="surname"/>
		  <span v-if="errors.first('surname')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <vs-input :label="$t('emailForPayment')" name="emailPay" v-validate="'required|email|min:3'"
                  v-model="emailPay"/>
		  <span v-if="errors.first('emailPay')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary ">
          <label class="vs-input--label">{{ $t('birthDate') }}</label>
          <div class="vs-con-input">
          </div>
          <vs-datepicker
            v-model="date"
            v-validate="'required'"
            name="date"
            format="dd.MM.yyyy"
          />
        </div>
		  <span v-if="errors.first('date')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <vs-phone
			:label="$t('phone')"
			name="phone"
			v-validate="'required|min:7|max:14'"
			v-model="phone"
		/>
		  <span v-if="errors.first('phone')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
          <label class="vs-input--label">{{ $t('sex') }}</label>
          <div class="vs-con-input">
          </div>
          <v-select
            v-model="sex"
            :reduce="country => country.id"
            label="name"
            v-validate="'required'"
            name="sex"
            :options="genders"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :clearable="false"
            class="single-row-select"
          />
        </div>
        <span v-if="errors.first('sex')" class="text-danger text-sm">
          {{ $t('fieldFilledIncorrect') }}
        </span>
      </div>

      <div class="form-input">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
          <label class="vs-input--label">{{ $t('country') }}</label>
          <div class="vs-con-input">
          </div>
          <v-select
			  v-model="country"
			  :reduce="country => country.id"
			  label="name"
			  v-validate="'required'"
			  name="sex"
			  :options="countries"
			  :dir="$vs.rtl ? 'rtl' : 'ltr'"
			  :clearable="false"
			  class="single-row-select"
		  />
        </div>
		  <span v-if="errors.first('country')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>

      <div class="form-input">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
          <label class="vs-input--label">{{ $t('aboutYourself') }}</label>
          <div class="vs-con-input">
          </div>
          <vs-textarea
			  v-model="about"
			  name="about"
			  class="mb-0"
			  v-validate="'required|min:3'"
			  style="height: 189px;"
		  />
        </div>
		  <span v-if="errors.first('about')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <div class="form-input">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary mt-5">
          <div class="vs-con-input">
          </div>
          <vs-upload
			  name="photo"
			  :text="$t('loadPhoto')"
			  accept=".jpg,.jpeg,.png"
			  :show-upload-button="false"
			  @change="togglePhoto"
			  @on-delete="deletePhoto"
		  ></vs-upload>
        </div>
		  <span v-if="errors.first('photo')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <div class="form-input w-full">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
          <label class="vs-input--label">{{ $t('language') }}</label>
          <div class="vs-con-input">
          </div>
          <v-select
			  :reduce="country => country.id"
			  v-validate="'required'"
			  label="name"
			  name="lang"
			  v-model="lang"
			  :options="languages"
			  :clearable="false"
			  :dir="$vs.rtl ? 'rtl' : 'ltr'"
			  class="single-row-select"
		  />
        </div>
		  <span v-if="errors.first('lang')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <div class="form-input w-full">
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
          <label class="vs-input--label">{{ $t('subject') }}</label>
          <div class="vs-con-input">
          </div>
          <v-select
			  v-model="subject"
			  v-validate="'required'"
			  :closeOnSelect="false"
			  :reduce="country => country.id"
			  :options="subjects"
			  :dir="$vs.rtl ? 'rtl' : 'ltr'"
			  multiple
			  name="subject" data
			  label="name"
		  />
        </div>
		  <span v-if="errors.first('subject')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <!-- Passwords -->
      <div class="form-input">
        <vx-input-group class="flex items-end">
          <vs-password
              :label="$t('password')"
              ref="password"
              data-vv-validate-on="blur"
              v-validate="'required|min:6|max:32'"
              type="password"
              name="password"
              v-model="password"
		  />
        </vx-input-group>
		  <span v-if="errors.first('password')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
      <div class="form-input">
        <vx-input-group class="flex items-end">
          <vs-password
              :label="$t('repeatPassword')"
              data-vv-validate-on="blur"
              v-validate="'required|confirmed:password'"
              type="password"
              name="repassword"
              ref="repassword"
              v-model="repassword"
		  />
        </vx-input-group>
		  <span v-if="errors.first('repassword')" class="text-danger text-sm">
			  {{ $t('fieldFilledIncorrect') }}
		  </span>
      </div>
    </div>
    <div class="flex flex-wrap justify-between mb-3 my-5">
      <vs-button
          @click="register"
	  >{{ $t('registration') }}</vs-button>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VsPassword from '../vs-password/VsPassword';
import databaseManager from '../../mixins/databaseManager';
import notifier from '../../mixins/notifier';
import moment from 'moment';

export default {
  name: 'registerUser',
  mixins: [databaseManager, notifier],
  data () {
    return {
      email: '',
      emailPay: '',
      name: '',
      surname: '',
      password: '',
      repassword: '',
      lang: [],
      subject: [],
      sex: '',
      country: '',
      phone: '',
      photo: '',
      about: '',
      date: '',

      countries: [],
      genders: [],
      languages: [],
      subjects: []
    }
  },
  components: {
	  VsPassword,
    'v-select': vSelect,
    Datepicker
  },
  computed: {
	  minDate() {
		  return new Date();
	  },
  },
  async mounted () {
    this.checkAccess()
    this.languages = (await this.$http.get('/settings/get-languages')).data.data
    this.subjects = (await this.$http.get('/settings/get-subjects')).data.data
    this.countries = (await this.$http.get('/settings/get-countries')).data.data
    this.genders = (await this.$http.get('/settings/get-genders')).data.data
  },
  methods: {
    async togglePhoto(err,file){
      try {
      	// let res = await this.dbUploadMany(file);
      	this.photo = file[file.length - 1];

      }catch (e) {
        this.notifyError(e.message);
      }
    },
	deletePhoto() {
      	this.photo = '';
	},
    async checkAccess () {
      try {
      	if(this.$store.state.auth.token) {
      		return;
		}

        let result = (await this.$http.post('/author/auth/validate-link', {uid: this.$route.query.id})).data.data.result;

        if (!result) {
		  this.notifyError('accessDenied');
        }
      } catch (e) {
		  this.notifyError('accessDenied');
        this.$router.go(-1)
      }
    },
    register () {
      this.$validator.validateAll().then(result => {
      	if(!this.photo) {
      		this.notifyError('addPhoto');
			return;
		}

        if (result) {
          let formData = {
			  email: this.email,
			  email_payment: this.emailPay,
			  first_name: this.name,
			  last_name: this.surname,
			  password: this.password,
			  password2: this.repassword,
			  languages: this.lang,
			  subjects: this.subject,
			  gender: this.sex,
			  country: this.country,
			  phone: this.phone,
			  about: this.about,
			  birth_date: moment(this.date).format("YYYY-MM-DD"),
			  uid: this.$route.query.id
		  };

		  this.$emit('register', formData, this.photo)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.con-input-upload {
  margin: 0;
  max-width: 200px;
  width: 100%;

  height: 191px;
}

.vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button {
  height: 2.74rem;
  margin-bottom: 1rem;
}

.con-img-upload {
  padding: 0;
}

.vs-textarea {
  height: 180px;
  resize: none !important;

  &:focus {
    resize: none !important;
  }
}

.img-upload {
  position: absolute !important;
  z-index: 9;
  margin: 0 !important;
}


</style>
